import React, { Component } from 'react';
import {  Tag, Space, Tooltip, Dropdown, Menu, Modal } from 'antd';
import { Button, Table ,Pagination,Box} from '@alifd/next';
import ProTable from '@ant-design/pro-table';
import { QuestionCircleOutlined, EllipsisOutlined } from '@ant-design/icons';  
const { confirm } = Modal;
import type { ProColumns } from '@ant-design/pro-table';

const { Column, ColumnGroup } = Table;

class BLProTable extends Component<any> {
  state = {
    result: [],
    pageSize: 10,
    selectedRowKeys: [],
    selectedRows: [],
    loading: false
  };

  private renderColumn = () => {
    let { columns } = this.props;

    let columnItems =
      columns?.map((v) => {
        return (
          (v?.columnName &&
            v?.fieldName && {
              title: (
                <>
                  {' '}
                  {v.fieldName}{' '}
                  {v.remark && (
                    <Tooltip placement="top" title={v.remark}>
                      <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                    </Tooltip>
                  )}
                </>
              ),
              sortable: v.isSorter ? true : false,
              key: v.columnName,
              dataIndex: v.columnName,
              valueType: v.businessFieldType,
              width: v.fieldWidth, 
              sortDirections : ["desc", "asc", "default"], 
              //onSort: v.isSorter ? (a, b) => a[v.columnName] - b[v.columnName] : false,
              align: v.align,
              fixed: v.fixed == 'none' ? false : v.fixed,
            }) ||
          {}
        );
      }) || [];

    return [...columnItems, this.renderColumnButtons()];
  };

  private renderMenuItem(list) {
    if (!list) return [];
    return (
      <Menu>
        {list?.map((v, index) => {
          return <Menu.Item key={index}>{v}</Menu.Item>;
        })}
      </Menu>
    );
  }

  showConfirm = (content, func) => {
    confirm({
      title: '注意',
      content: content,
      onOk() {
        func();
      },
      onCancel() {},
    });
  };
  renderColumnButtons() {
    let { columnButtons = [], columnButtonNum, columnButtonWidth = 120 } = this.props;

    return columnButtons.length > 0
      ? {
          cell:(text, record) => {
            return this._renderTableItemArr_(columnButtons, record);
            //return [...preVarr, dropDownItem];
          },
          title: "操作",
          key: 'option', 
          width: columnButtonWidth,
          valueType: 'option',
        }
      : [];
  }
  objToprams = (obj) => {
    return Object.keys(obj)
      .map((v) => {
        return `${v}=${obj[v]}`;
      })
      .join('&');
  };
  btnActionFun = (v, record) => {
    let { actionType, dialogId, jumpPageType, jumpType, dataSource, pageurl, parms, commitTxt } =
      v.behavior;
    let _this = this;

    let selfobj = {};
    if (parms) {
      parms.map((v) => {
        selfobj[v] = record[v];
      });
    } else {
      selfobj = record;
    }

    let parmsObj = {}
    v.parmsData?.map(v=>{
      parmsObj[v.split(".").length >1 ? v.split(".")[1]: v] = this.props.getState(v)
    })

    if (actionType == 1 && pageurl) {
      window.open(pageurl + '?' + this.objToprams({...selfobj}));
    }

    if (commitTxt) {
      this.showConfirm(commitTxt, () => {
        if (dataSource) {
          let dataSourceId = dataSource.split('this.state.')[1];
          this.props.dataSourceLoad(dataSourceId , {...selfobj,...parmsObj} , () => {
            this.reload()
          } )  
        }
      });
    }else{
      if (dataSource) {
        let dataSourceId = dataSource.split('this.state.')[1];
        this.props.dataSourceLoad(dataSourceId , {...selfobj,...parmsObj} , () => {
          this.reload()
        } )  
      }
    }

    // this.props.getroot(function() {
    //   this.setState({
    //     "di": true
    //   })
    //  });
  };
  reload = () => { 
    let tableDataId = this.props.dataSourceId?.split('this.state.')[1];
    this.props.dataSourceLoad(tableDataId)
  };
  btnBarActionFun = (v, record) => {
    let { actionType, dialogId, jumpPageType, jumpType, parms,dataSource, pageurl ,pageData} = v.behavior;
    let _this = this


    if (actionType == 1 && pageurl) {
      window.open(pageurl + '?' + this.objToprams(record));
    }
    
    let { selectedRowKeys, selectedRows } = this.state;
 
    let pageDataObj = {} 
    pageData.map(v=>{
      pageDataObj[v] = this.props.getState(v)
    })
    let parmsObj = {}
    
    parms?.map(v=>{
      parmsObj[v]= selectedRows.map(i => (i[v])) 
    })

    console.log("pageData",parms,parmsObj)
    if (dataSource) {
      let dataSourceId = dataSource.split('this.state.')[1];
      this.setState({
        loading : true
      })
      this.props.dataSourceLoad( dataSourceId,{ id: selectedRowKeys, ...pageDataObj , ...parmsObj} , ()=>{
        _this.setState({
          loading : false 
        })
      })
      
    }
    // this.props.getroot(function() {
    //   this.setState({
    //     "di": true
    //   })
    //  });
  };
  _renderTableItemArr_(item: Array, record) {
    let { columnButtons = [], columnButtonNum, columnButtonWidth = 120 } = this.props;
    let menuList = [];
    let preVarr = [];

    columnButtons?.map((v, index) => {
      if (index >= columnButtonNum) {
        menuList.push(
          <a
            onClick={() => {
              this.btnActionFun(v, record);
            }}
          >
            {' '}
            {v.btnName}
          </a>,
        );
      } else {
        preVarr.push(
          <a
            onClick={() => {
              this.btnActionFun(v, record);
            }}
          >
            {' '}
            {v.btnName}
          </a>,
        );
      }
    });

    let dropDownItem =
      columnButtonNum < columnButtons.length ? (
        <Dropdown overlay={this.renderMenuItem(menuList)}>
          <a onClick={(e) => e.preventDefault()}>
            <EllipsisOutlined />
          </a>
        </Dropdown>
      ) : (
        []
      );
    return [...preVarr, dropDownItem];
  }

  private renderHeaderTitle() {
    let { tableControlButtons } = this.props;

    return (
      tableControlButtons?.map((v, index) => {
        return (
          <Button
            type="primary"
            key={index}
            onClick={() => {
              this.btnBarActionFun(v);
            }}
          >
            {v.btnName}
          </Button>
        );
      }) || []
    );
  }

  private getRowSelection() {
    let { chooseType } = this.props;
    if (chooseType === 'none') return false;

    return {
      selectedRowKeys: this.state.selectedRowKeys,
      mode: chooseType === "checkbox" ? "multiple" : "single",
      onChange: (selectedRowKeys, selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys, selectedRows });
        console.log(':e', this.state.selectedRowKeys);
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column configuration not to be checked
        id: record.region_name,
      }),
    };
  }

  onChangePage = (page: number ) => {
    const {pageSize } = this.props 
    let tableDataId = this.props.dataSourceId?.split('this.state.')[1];
    this.props.dataSourceLoad(tableDataId,{ pageNum: page , pageSize:pageSize })
 
  };
  onSort(dataIndex, order) {
    console.log(12323,dataIndex, order ,this.props.tableData)
    console.log(dataIndex, order, "======");
    const dataSource = this.props.tableData.result.sort(function(a, b) {
      const result = parseFloat(a[dataIndex]) - parseFloat(b[dataIndex]); 
      return order === "asc" ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
    }); 
    console.log(42334, dataSource)
  }
  private getPagination() {
    let { isPage, pageSize } = this.props; 
    // return {
    //   show: isPage,
    //   pageSize: pageSize ? pageSize : 20,
    //   current: 1,
    //   total: this.props.tableData?.total ? this.props.tableData?.total : 20,
    //   onChange: (page: number, pageSize: number) => this.onChangePage(page, pageSize),
    // };
    return (
      <Pagination
      pageSize={pageSize ? pageSize : 20}
      total={ this.props.tableData?.total ? this.props.tableData?.total : 20}
      current={1} 
      onChange={(page: number, pageSize: number) => this.onChangePage(page)}
    />
    )
  }

  render() {
    return (
      <Box spacing={10} padding={10}>
        {/* <ProTable
          rowKey={(record) => record.id}
          dataSource={this.props.tableData?.result || []}
          rowSelection={this.getRowSelection()}
          size={this.props.size || 'small'}
          search={false}
          bordered={this.props.isBordered}
          headerTitle={<Space>{this.renderHeaderTitle()}</Space>}
          pagination={this.getPagination()}
          loading = {this.state.loading}
          columns={this.renderColumn()}
          options={{ fullScreen: true }}
          onReset={this.reload()}
          scroll={this.props.isScroll ? { y: 240 } : false}
        ></ProTable> */}
        
        <Box direction="row"  spacing={10}>
          {this.renderHeaderTitle()}
        </Box> 
        <Table 
          onSort={this.onSort.bind(this)}
          rowKey={(record) => record.id}
          isZebra={this.props.isZebra}
          dataSource={this.props.tableData?.result || []}
          rowSelection={this.getRowSelection()}
          size={this.props.size || 'small'}
          search={false}
          hasBorder={this.props.isBordered} 
          loading = {this.state.loading}
          columns={this.renderColumn()}
          options={{ fullScreen: true }}
          onReset={this.reload()}
          scroll={this.props.isScroll ? { y: 240 } : false}
        >  
        </Table>   
        {this.getPagination()}
      </Box>
    );
  }
}

export default BLProTable;
